import { render, staticRenderFns } from "./copyHuis.vue?vue&type=template&id=f29952c2"
import script from "./copyHuis.vue?vue&type=script&lang=js"
export * from "./copyHuis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports